// extracted by mini-css-extract-plugin
export default {"sort":"Archive_sort__EkunA","actions":"Archive_actions__+ZvRM"};